import React from 'react'
import images from '../../../../app/utlis/image'

const EnterpriseApplication = () => {
    return (
        <div className='bg-darkGreyPrimary flex flex-col md:flex-row justify-center items-center py-8 md:py-0'>
            <div className='px-4 md:p-8 md:pl-32 text-center md:text-left'>
                <div className='text-yellow font-bold text-3xl md:text-4xl mb-4 leading-snug'>Start your Enterprise App
                    development today</div>
                <div className='text-base md:text-lg leading-7 md:leading-8'>Our experienced team is ready to build a custom enterprise app
                    that will help your business operate more efficiently and
                    grow. Get in touch today for a free consultation.</div>
            </div>
            <img src={images.MODEREQUIPPED} className='w-full md:w-2/4 mt-8 md:mt-0'/>
        </div>
    )
}

export default EnterpriseApplication
